// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3qBO3","vLegacy":"SelectSecondary_vLegacy__1WoFY","error":"SelectSecondary_error__z7Eup","disabled":"SelectSecondary_disabled__1mvy8"};